import React from "react";
import {withStyles} from "@material-ui/core";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader";
import Info from "components/Typography/Info";


import blogsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/blogsStyle.js";
import Success from "../../components/Typography/Success";
import Warning from "../../components/Typography/Warning";
import TrendingUp from "@material-ui/core/SvgIcon/SvgIcon";
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import Primary from "../../components/Typography/Primary";
import intl from 'react-intl-universal';


class SeriesItem extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			dateDif: intl.get('today')
		};

		const dateStart = new Date(this.props.data.seriesUpdate);
		const dateEnd = new Date();
		const difValue = (dateEnd - dateStart) / (1000 * 60 * 60 * 24);

		if (difValue < 1) {
			this.state.dateDif = intl.get('today')
		} else if (difValue < 30) {
			this.state.dateDif = parseInt(difValue) + intl.get('days_ago')
			// } else if (difValue < 30) {
			// 	this.state.dateDif = "本月"
		} else {
			this.state.dateDif = intl.get('more_than_a_month')
		}
	}

	render() {
		const {classes} = this.props;
		const data = this.props.data;
		return (
			<Card plain blog className={classes.card}>
				<GridContainer>
					<GridItem xs={12} sm={4} md={4}>
						<CardHeader image plain style={{paddingTop: '12px'}}>
							<a
								href={`/series_info/${data.seriesId}`}
							>
								<img src={data.imageUrl} alt="..."/>
							</a>
							<div
								className={classes.coloredShadow}
								style={{
									backgroundImage: `${data.imageUrl}`,
									opacity: "1"
								}}
							/>
							<div
								className={classes.coloredShadow}
								style={{
									backgroundImage: `${data.imageUrl}`,
									opacity: "1"
								}}
							/>
						</CardHeader>
					</GridItem>
					<GridItem xs={12} sm={8} md={8}>
						{data.seriesStatus === "0" ?
							<Info>
								<h5 className={classes.cardCategory}>
									<CheckCircleIcon/>&nbsp;
									{intl.get('finish')}
								</h5>
							</Info>
							:
							<Warning>
								<h5 className={classes.cardCategory}>
									<TrendingUpIcon/>&nbsp;
									{intl.get('latest')}
								</h5>
							</Warning>
						}
						&nbsp;&nbsp;&nbsp;&nbsp;
						{
							data.userHave ?
								<Success>
									<h5 className={classes.cardCategory}>
										<CheckCircleIcon/>&nbsp;
										{intl.get('can_play')}
									</h5>
								</Success>
								:
								null
						}

						<h3 className={classes.cardTitle}>
							<a href={`/series_info/${data.seriesId}`}>
								{data.seriesName}
							</a>
						</h3>
						<p>{data.seriesInfo}
						</p>
						<p className={classes.author}>
							by{" "}
							<b>RobinAlgo</b>
							{" "}
							,
							update{" "}
							<b>
								{this.state.dateDif}
							</b>
						</p>
					</GridItem>
				</GridContainer>
			</Card>
		);
	}
}

export default withStyles(blogsStyle)(SeriesItem)